/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Limit } from '../models/Limit';
import type { LimitIn } from '../models/LimitIn';
import type { LimitList } from '../models/LimitList';
import type { ListArgs } from '../models/ListArgs';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LimitService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Limit Objects List
     * @param requestBody
     * @returns LimitList Successful Response
     * @throws ApiError
     */
    public getLimitList(
        requestBody: ListArgs,
    ): CancelablePromise<LimitList> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/Limit',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Limit Object Create
     * @param requestBody
     * @param itemId
     * @returns Limit Successful Response
     * @throws ApiError
     */
    public newLimit(
        requestBody: LimitIn,
        itemId?: (number | null),
    ): CancelablePromise<Limit> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/Limit',
            query: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Limit Object Get
     * @param itemId
     * @returns Limit Successful Response
     * @throws ApiError
     */
    public getLimit(
        itemId: number,
    ): CancelablePromise<Limit> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/Limit/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Limit Object Update
     * @param itemId
     * @param requestBody
     * @returns Limit Successful Response
     * @throws ApiError
     */
    public updLimit(
        itemId: (number | null),
        requestBody: LimitIn,
    ): CancelablePromise<Limit> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v2/Limit/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Limit Object Delete
     * @param itemId
     * @returns any Successful Response
     * @throws ApiError
     */
    public delLimit(
        itemId: number,
    ): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/Limit/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
